<template>
  <div class="m-activity-buyerList">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="120" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :offset="offset" :total="total" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
      <template #couponName="{ row }">{{ row.couponName }}</template>
      <template #couponKind="{ row }">{{ couponKindMap[row.couponKind] }}</template>
      <template #payStatus="{ row }">{{ row.payStatus }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn" type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from "@/components/AuthButton";
import { api_getCouponBuyRecordList, api_getGiftCouponBuyRecordList, api_getActivityRecordExport, api_getExportGiftCoupoonSellRecord } from "@/api/market";
import { api_getUserPhone } from "@/api/common";
import aes from "@/common/aes.js";
import { downFile } from "@/utils";
import Table from "@/components/Table/index";
import Search from "@/components/Search/index";

export default {
  name: "marketActivityListIndex",
  components: {
    AuthButton,
    Table,
    Search
  },
  props: {
    couponKind: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      form: {
        statusList:'all'
      },
      tableKey: false,
      exportLoading: false,

      renderData: [
        {
          label: "支付状态",
          placeholder: "请选择支付状态",
          type: "select",
          key: "statusList",
          option: [
            { label: '全部', value: 'all' },
            { label: '支付完成', value: 'PaymentSuccess' },
            { label: '已退款', value: 'Refund' }
          ],
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone"
        },
        {
          label: "购买时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp',
        },
      ],
      tableThData: [
        { prop: "couponName", label: "券名称", minWidth: "180" },
        { prop: "couponKind", label: "券类型", minWidth: "180" },
        { prop: "phone", label: "会员手机号", minWidth: "180" },
        { prop: "payStatus", label: "支付状态", minWidth: "180" },
        { prop: "payTime", label: "购买时间", minWidth: "180" },
        { prop: "source", label: "来源", minWidth: "120" }
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      couponKindMap: {
        Coupon: "优惠券",
        GiftCoupon: "礼品券",
        WelfareCoupon: "福利券",
        Recharge: "直充商品"
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取表格列表数据
    async getList() {
      this.loading = true;
      const params = {
        activityId: this.$route.query.id,
        couponKind: this.couponKind,
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        statusList: this.form.statusList=='all'?'':this.form.statusList,
      };
      this.form.time && this.form.time[0] && (params.startTime = this.form.time[0])
      this.form.time && this.form.time[1] && (params.endTime = this.form.time[1])
      delete params.time
      try {
        if (this.couponKind == "GiftCoupon") {
          const data = await api_getGiftCouponBuyRecordList(params);
          this.tableTrData = data.list;
          this.total = data.count;
        } else {
          const data = await api_getCouponBuyRecordList(params);
          this.tableTrData = data.list;
          this.total = data.count;
        }
        this.loading = false;
      } catch {
        this.loading = false;
      }
    },

    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show;
      } else {
        const { phone } = await api_getUserPhone({ id: row.userId });
        this.tableTrData[index].phone_show = aes.decrypt(phone);
      }
      this.tableKey = !this.tableKey;
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
        statusList: this.form.statusList=='all'?'':this.form.statusList,
      }
      this.form.time && this.form.time[0] && (params.startTime = this.form.time[0])
      this.form.time && this.form.time[1] && (params.endTime = this.form.time[1])
      delete params.time
      let res = null
      if (this.couponKind == "Coupon" || this.couponKind == "WelfareCoupon" || this.couponKind == "Recharge") {
        params.exportType = 'SaleCoupon'
        res = await api_getActivityRecordExport(params)
      } else if (this.couponKind == "GiftCoupon") {
        res = await api_getExportGiftCoupoonSellRecord(params)
      }

      res && downFile(res)
      this.exportLoading = false
    },

    handleSizeChange(limit) {
      this.limit = limit;
      this.getList();
    },

    handleCurrentChange(offset) {
      this.offset = offset;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.m-activity-buyerList {
  box-sizing: border-box;

  .el-button {
    min-width: 80px !important;
  }
}
</style>
